import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "container top-0 position-sticky z-index-sticky" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-12" })
  ])
], -1)
const _hoisted_2 = { class: "mt-0 main-content" }
const _hoisted_3 = { class: "page-header min-vh-100" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0" }
const _hoisted_7 = { class: "card card-plain" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "pb-0 card-header text-start" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "font-weight-bolder" }, "Entrar"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0" })
], -1)
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Lembre-me")
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Entar")
const _hoisted_15 = {
  key: 0,
  class: "text-center font-weight-bolder"
}
const _hoisted_16 = { class: "top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column" }
const _hoisted_17 = { class: "position-relative bg-jauserve h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden" }
const _hoisted_18 = { class: "mt-5 text-white font-weight-bolder position-relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_argon_input = _resolveComponent("argon-input")!
  const _component_argon_switch = _resolveComponent("argon-switch")!
  const _component_argon_button = _resolveComponent("argon-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("section", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_argon_input, {
                        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.username=$event.target.value)),
                        type: "email",
                        placeholder: "Email",
                        name: "email",
                        size: "lg"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_argon_input, {
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.password=$event.target.value)),
                        type: "password",
                        placeholder: "Password",
                        name: "password",
                        size: "lg"
                      })
                    ]),
                    _createVNode(_component_argon_switch, {
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.save=$event.target.checked)),
                      id: "rememberMe"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_argon_button, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doLogin())),
                        class: "mt-4",
                        variant: "gradient",
                        color: "primary",
                        fullWidth: "",
                        size: "lg"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      })
                    ]),
                    (_ctx.error.show)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_15, _toDisplayString(_ctx.error.message), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("h4", _hoisted_18, _toDisplayString(_ctx.$app_name), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}